import * as type from "../types";

const initialRentState = {
    nazwa: "",
    rodzaj_id: 0,
    ulica: "",
    kod: "",
    miasto: "",
    email: "",
    pesel: "",
    nip: "",
    telefon: "",
    regon: "",
    uwagi: "",
    kierowca1_imie: "",
    kierowca1_ulica: "",
    kierowca1_kod: "",
    kierowca1_miasto: "",
    kierowca1_pesel: "",
    kierowca1_telefon: "",
    kierowca1_prawo_organ: "",
    kierowca1_prawo_data: null,
    kierowca1_prawo_nr: "",
    kierowca2_imie: "",
    kierowca2_ulica: "",
    kierowca2_kod: "",
    kierowca2_miasto: "",
    kierowca2_pesel: "",
    kierowca2_telefon: "",
    kierowca2_prawo_organ: "",
    kierowca2_prawo_data: null,
    kierowca2_prawo_nr: "",
    czas_od: 1585070357,
    czas_do: null,
    opis: "",
    nr_rej_napr: "",
    limitkm: 0,
    limitkm_rodzaj: 0,
    pool_st_pow_lim_km: 0,
    ryczalt: 0,
    ryczalt_rodzaj: "",
    numer_zlecenia_serwisowego: ""
};

const rentStateSettings = {
    akcesoria: "",
    akcesoria_opcje: [],
    apteczka: false,
    czysty_wewnatrz: false,
    czysty_zewnatrz: false,
    dokumenty: false,
    gasnica: false,
    inne: "",
    narzedzia: false,
    radio: false,
    trojkat: false
};

const rendDefaultSettings = {
    limitkm: 0,
    limitkm_rodzaj: "",
    limitkm_rodzaj_opcje: [],
    opis: "",
    rodzaj_ryczalt_opcje: [],
    ryczalt_kwota: "",
    ryczalt_rodzaj: "",
    stawka_km: ""
};

const initialSettings = {
    domyslne_ustawienia: rendDefaultSettings,
    stan_rozpoczecia: rentStateSettings,
    stan_zakonczenia: rentStateSettings,
};

const initialState = {
    rent: initialRentState,
    clients: [],
    settings: initialSettings,
    pricing: [],
    operators: [],
    readyToSave: {
        stan_rozpoczecia: false,
        stan_zakonczenia: false,
        domyslne_ustawienia: false
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case type.SET_RENT:
            return {
                ...state,
                rent: action.value
            };
        case type.SET_RENT_SETTINGS:
            return {
                ...state,
                settings: action.value
            };
        case type.SET_RENT_CLIENTS:
            return {
                ...state,
                clients: action.value
            };
        case type.UPDATE_RENT_CLIENT:
            return {
                ...state,
                clients: state.clients.map(client => {
                    if (client.klient_id === action.value.klient_id)
                        return action.value;
                    return client;
                })
            };
        case type.SET_RENT_PRICING:
            return {
                ...state,
                pricing: action.value
            };
        case type.UPDATE_RENT_PRICING:
            return {
                ...state,
                pricing: state.pricing.map(singlePricing => {
                    if (singlePricing.cennik_id === action.value.cennik_id)
                        return action.value;
                    return singlePricing;
                })
            };
        case type.SET_RENT_OPERATORS:
            return {
                ...state,
                operators: action.value
            };
        case type.UPDATE_RENT_OPERATORS:
            return {
                ...state,
                operators: state.operators.map(operator => {
                    if (operator.operator_id === action.value.operator_id)
                        return action.value;
                    return operator;
                })
            };
        case type.CHANGE_SAVE_SETTINGS:
            return {
                ...state,
                readyToSave: action.value
            };
        default:
            return state;
    }
};
